// CP-17: lightweight affiliate CTA event bus.
// Avoids adding Vuex/mitt for a single toast trigger; components subscribe
// with affiliateBus.on(...) (returns an unsubscribe fn) and fire clicks with
// affiliateBus.emit(payload).

const handlers = new Set();

const affiliateBus = {
  on(handler) {
    handlers.add(handler);
    return () => handlers.delete(handler);
  },
  emit(payload) {
    handlers.forEach((handler) => handler(payload));
  }
};

// Fire when an enabled affiliate CTA is clicked; payload carries the partner
// display name so the toast can read "Opening <Partner> in a new tab...".
export function notifyAffiliateClick(payload) {
  affiliateBus.emit(payload || {});
}

export default affiliateBus;